export const TriggerAttributes = {
  assignee_id: 'assignee_id',
  author_id: 'author_id',
  document_public: 'document_public',
  document_type: 'document_type',
  leave_type_id: 'leave_type_id',
  leave_type: 'leave_type',
  folder_id: 'folder_id',
  send_notifications: 'send_notifications',
  review_request_state: 'review_request_state',
  first_name: 'first_name',
  last_name: 'last_name',
  gender: 'gender',
  location_id: 'location_id',
  legalEntityId: 'legal_entity_id',
  team_id: 'team_id',
  age: 'age',
  city: 'city',
  state: 'state',
  country: 'country',
  addressLine1: 'address_line_1',
  addressLine2: 'address_line_2',
  postalCode: 'postal_code',
  nationality: 'nationality',
  identifier: 'identifier',
  social_security_number: 'social_security_number',
  bank_number: 'bank_number',
  bankNumberFormat: 'bank_number_format',
  employee_id: 'employee_id',
  manager_id: 'manager_id',
  timeoff_manager_id: 'timeoff_manager_id',
  birthday: 'birthday',
  custom_fields: 'custom_fields',
  custom_resources: 'custom_resources',
  startsOn: 'starts_on',
  endsOn: 'ends_on',
  jobTitle: 'job_title',
  hasPayroll: 'has_payroll',
  salaryAmount: 'salary_amount',
  workingHours: 'working_hours',
  workingHoursFrequency: 'working_hours_frequency',
  spainProfessionalCategories: 'contracts_es_professional_category_id',
  swiftBic: 'swift_bic',
  employeeActive: 'active',
  trialPeriodEndsOn: 'trial_period_ends_on',
  educationLevel: 'education_level',
  cotizationGroup: 'cotization_group',
  salaryFrequency: 'salary_frequency',
  workingDayType: 'working_day_type',
  contractType: 'contract_type',
  professionalCategory: 'professional_category',
  jobCatalogRole: 'job_catalog_role',
  costCenterId: 'cost_center_id',
  employeeGroupId: 'employee_group_id',
}
